import { render, staticRenderFns } from "./tpm_activity.vue?vue&type=template&id=b5fbc276&scoped=true"
import script from "./tpm_activity.vue?vue&type=script&lang=js"
export * from "./tpm_activity.vue?vue&type=script&lang=js"
import style0 from "./tpm_activity.vue?vue&type=style&index=0&id=b5fbc276&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5fbc276",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b5fbc276')) {
      api.createRecord('b5fbc276', component.options)
    } else {
      api.reload('b5fbc276', component.options)
    }
    module.hot.accept("./tpm_activity.vue?vue&type=template&id=b5fbc276&scoped=true", function () {
      api.rerender('b5fbc276', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/pay_center/write_off/components/write_off_details/visitDetail/components/tpm_activity.vue"
export default component.exports